import LiveJobs from "../components/Sections/LiveJobs";
import OurCandidates from "../components/Sections/OurCandidates";

export default function RecruitmentPage() {
  return (
      <>
          <OurCandidates />
  
      </>
  ) 
}